/**
 * The shapes the printed layouts read.
 *
 * A document is kept as Xero returns it, field names and all, rather than
 * flattened into something of our own. Two layouts read it and both are drawing
 * what Xero holds; a translation layer in between would be one more place for
 * an amount to change meaning on its way to paper.
 */

export interface LineItem {
  Description?: string;
  Quantity?: number;
  UnitAmount?: number;
  LineAmount?: number;
  AccountCode?: string;
  TaxAmount?: number;
}

export interface XeroDocument {
  Type?: string;
  Status?: string;
  InvoiceNumber?: string;
  Reference?: string;
  DateString?: string;
  DueDateString?: string;
  CurrencyCode?: string;
  SubTotal?: number;
  TotalTax?: number;
  Total?: number;
  AmountDue?: number;
  AmountPaid?: number;
  Contact?: { Name?: string; EmailAddress?: string };
  LineItems?: LineItem[];
}

/** How one company's documents look, from its branding record. */
export interface Presentation {
  /** 'standard' is the plain bilingual sheet; 'banded' is a company's own. */
  template: string;
  taglineAr: string;
  taglineEn: string;
  /** #rrggbb, or empty for the layout's default. */
  accentColour: string;
  bandColour: string;
  bank: {
    name: string;
    accountName: string;
    accountNumber: string;
    iban: string;
  };
  terms: string;
}

export const EMPTY_PRESENTATION: Presentation = {
  template: 'standard',
  taglineAr: '',
  taglineEn: '',
  accentColour: '',
  bandColour: '',
  bank: { name: '', accountName: '', accountNumber: '', iban: '' },
  terms: '',
};
